import React, { useEffect, useState } from "react";
import axios from "axios";
import { backend_url } from "../App";
import "./CSS/varietyAccessories.css";
import { ToastContainer, toast } from "react-toastify";
import { isAdmin } from "../utils/roleUtils";
import "react-toastify/dist/ReactToastify.css";
import MediaField from "../Components/MediaField/MediaField";
import DownloadButton from "../Components/MediaField/DownloadButton";
import { MAX_IMAGE_MB } from "../utils/media";

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [formData, setFormData] = useState({
    answer: "",
    question: "",
    icon_image: null,
  });
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [existingImage, setExistingImage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleDelete = (_id) => {
    setSelectedVideoId(_id);
    setShowConfirm(true);
  };

  // Handle delete
  const confirmDelete = async (id) => {
    try {
      await axios.delete(`${backend_url}/api/faq/${id}`);
      setShowConfirm(false);
      toast.success("FAQ deleted Successfully");
      fetchFaq();
    } catch (error) {
      toast.error("Error deleting FAQ:", error);
    }
  };

  // Fetch all FAQ
  useEffect(() => {
    fetchFaq();
  }, []);

  const fetchFaq = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/faq`);
      setFaqs(response.data);
    } catch (error) {
      toast.error("Error fetching faq:", error);
    }
  };

  // Handle form input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Add or update FAQ
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.icon_image && !existingImage) {
      toast.error("Please choose an icon image");
      return;
    }

    const data = new FormData();
    data.append("question", formData.question);
    data.append("icon_image", formData.icon_image || existingImage);
    data.append("answer", formData.answer);

    try {
      if (editingId) {
        await axios.put(`${backend_url}/api/faq/${editingId}`, data);
        toast.success("FAQ Updated Successfully");
      } else {
        await axios.post(`${backend_url}/api/faq`, data);
        toast.success("FAQ Added Successfully");
      }
      fetchFaq();
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.error || "Error saving FAQ");
    }
  };

  // Handle edit
  const handleEdit = (faq) => {
    setFormData({
      question: faq.question,
      icon_image: null,
      answer: faq.answer,
    });
    setExistingImage(faq.icon_image || "");

    setEditingId(faq._id);
    setShowModal(true);
  };

  // Close modal and reset form
  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData({ icon_image: null, question: "", answer: "" });
    setExistingImage("");
  };
  return (
    <>
      <div className="variety-admin">
        <div className="headerSections">
          <div className="head-title">FAQ</div>
          <button className="add-btn" onClick={() => setShowModal(true)}>
            + Add FAQ
          </button>
        </div>

        {/* Popup Modal */}
        {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal" onClick={(e) => e.stopPropagation()}>
              <h2>{editingId ? "Edit FAQ" : "Add FAQ"}</h2>
              <form onSubmit={handleSubmit} className="variety-form">
                <div className="form-group">
                  <label htmlFor="question">Question</label>
                  <input
                    type="text"
                    id="question"
                    name="question"
                    value={formData.question}
                    onChange={handleChange}
                    maxLength={200}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="answer">Answer</label>
                  <input
                    type="text"
                    maxLength={500}
                    id="answer"
                    name="answer"
                    value={formData.answer}
                    onChange={handleChange}
                    required
                  />
                </div>
                <MediaField
                  id="icon_image"
                  label="Image"
                  file={formData.icon_image}
                  existingUrl={existingImage}
                  maxMB={MAX_IMAGE_MB}
                  onFileSelect={(file) => setFormData({ ...formData, icon_image: file })}
                />

                <div className="form-buttons">
                  <button type="submit" className="submit-btn">
                    {editingId ? "Update" : "Add"}
                  </button>
                  <button
                    type="button"
                    onClick={closeModal}
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* List Table */}
        <table className="variety-table">
          <thead>
            <tr>
              <th>Question</th>
              <th>Answer</th>
              <th>Icon</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {faqs.map((faq) => (
              <tr key={faq._id}>
                <td>{faq.question}</td>
                <td>{faq.answer}</td>
                <td>
                  <div className="media-cell">
                    <img src={faq.icon_image} alt="icon_image" />
                    <DownloadButton url={faq.icon_image} />
                  </div>
                </td>
                <td>
                  <button onClick={() => handleEdit(faq)}>Edit</button>
                  {isAdmin() && <button onClick={() => handleDelete(faq._id)}>Delete</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Confirmation Popup */}
      {showConfirm && (
        <div className="confirm-popup">
          <div className="confirm-content">
            <p>Are you sure you want to delete this category?</p>
            <div className="popup-actions">
              <button
                onClick={() => confirmDelete(selectedVideoId)}
                className="confirm-btn"
              >
                Confirm
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default FAQ;
